<template>
    <div>
        <Header />
		<div class="banners">
			<Banner :src="src" />
		</div>
        <div style="width:70%;margin:0 auto;padding-bottom:30px;" class="content">
            <h2 style="margin-top:20px;font-size:32px;font-weight:550px;line-height:120px">业绩详情</h2>
            <iframe :src="investorDec" frameborder="0" width="100%" height="1000px" class="iframeContent"></iframe>
		</div>
        <Footer />
    </div>
</template>
<script>
import Header from '../../components/Header.vue'
import Banner from '../../components/Banner.vue'
import Footer from '../../components/Footer.vue'
import Axios from "axios"
const Base64=require('js-base64');
export default {
    components:{Header,Banner,Footer},
    data(){
        return{
            src:'',
            dec:'',
            investorDec:'',
        }
    },
    mounted(){
        this.dec=this.$route.query.detailText;
       this.investorDec=this.dec
        Axios({
				url: '/apiv2/sconfig/getlist',
				data: {},
				method: 'GET',
			}).then((res) => {
				for(var i=0;i<res.data.data.rows.length;i++){
					if(res.data.data.rows[i].sc_key.slice(0,11)=="PRICEBANNER"){
						this.src=res.data.data.rows[i].sc_value
					}
				}
			})
    }
}
</script>
<style scoped>
::v-deep font{
	line-height: 40px;
}
::v-deep span{
	line-height: 40px;
}
::v-deep p{
	line-height: 40px;
}
@media (max-width: 1199px) {
	@import '../../style/mb.scss';
	@import './m_index.scss';
    .content{
        width: 80% !important;
        padding-bottom: 30px !important;
        -webkit-overflow-scrolling: touch;
        overflow-y: scroll;
    }
    .iframeContent{
        width: 100%;
    }

}
</style>